
















































import {
  computed,
  defineComponent,
  Ref,
  ref,
} from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';

import debtorOption from '@/table/setting/debtor';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonFormWithDebtorEditor from '@/components/Setting/CommonFormWithDebtorEditor.vue';

import getDebtors from '@/gql/debtor/getDebtors.gql';
import deleteDebtor from '@/gql/debtor/deleteDebtor.gql';

const Debtor = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonFormWithDebtorEditor,
  },
  setup() {
    const addDebtorModal = ref(null);
    const editDebtorId = ref(-1);

    const search: Ref<string> = ref('');
    const getDebtorsResult = (data: any) => data.debtors;
    // ==== Use to search User ==== //
    const getDebtorsVariables = computed(() => {
      const vars: {[key: string]: any} = {
        filterName: undefined,
        filterCode: undefined,
        filterTaxId: undefined,
      };
      if (search.value) {
        vars.filterName = `%${search.value}%`;
      }
      return vars;
    });

    // ============================================
    // ===== Use to delete Debtor from system =====
    // ============================================
    const deleteDebtorModal = ref(null);
    const deleteDeliveryMutation = useMutation(deleteDebtor, {
      refetchQueries: ['getDebtors'],
    });
    function deleteDebtorAction(deliveryId: number) {
      deleteDeliveryMutation.mutate({
        id: deliveryId,
      });
    }

    return {
      getDebtorsQuery: getDebtors,
      debtorOption,
      getDebtorsResult,
      getDebtorsVariables,
      search,

      addDebtorModal,
      editDebtorId,

      deleteDebtorModal,
      deleteDebtorAction,
    };
  },
});

export default Debtor;
